import { Serializer, UISerializableDepositRecord } from '@drift/common';
import { getDepositHistoryFilter } from 'src/utils/historyTables';
import { useComposedHistory } from './useComposedHistory';
import type { HistoryTableUIProps } from './historyDataTypes';

export const useDepositsHistory =
	(): HistoryTableUIProps<UISerializableDepositRecord> => {
		const { historyData, executePageChange } = useComposedHistory(
			'deposits',
			Serializer.Deserialize.UIDeposit
		);

		return {
			executePageChange,
			filterFn: getDepositHistoryFilter,
			historyData,
		};
	};
